
/** @param {HTMLElement} rootElement */
export function addExportWarningListeners(rootElement) {
    rootElement = typeof rootElement !== 'undefined' ? rootElement : document;

    // Display warnings for export buttons
    rootElement.querySelectorAll('.action-export-warning').forEach(function (element) {
        if (element.classList.contains('button-container')) {
            element = element.firstElementChild;
        }
        element.addEventListener('click', (event) => {
            if (!element.hasAttribute('data-export-warning')) {
                event.preventDefault();
                event.stopImmediatePropagation();

                const labelElements = element.getElementsByClassName('label');

                const warningMessage = 'Vous exportez des informations potentiellement sensibles. Veuillez utiliser et stocker ces données de manière responsable.';
                const link = {
                    "href": element.getAttribute('href'),
                    "label": labelElements.length ? labelElements[0].textContent : element.textContent
                };

                BootstrapDialog.show({
                    size: BootstrapDialog.SIZE_WIDE,
                    type: BootstrapDialog.TYPE_DANGER,
                    title: '⚠️ Export de données sensibles',
                    message: warningMessage,
                    buttons: [
                        {
                            label: link.label,
                            action: (dialog) => {
                                dialog.close();
                                if (link.href) {
                                    window.open(link.href);
                                } else {
                                    element.setAttribute('data-export-warning', 'true');
                                    element.click();
                                }
                            }
                        },
                        {
                            label: 'Annuler',
                            cssClass: 'btn-secondary',
                            action: function (dialog) {
                                dialog.close();
                            }
                        }
                    ]
                });
            }
        });
    })
}
